import React from 'react'
import StaffRegister from '../../components/staffdetailscomponents/StaffRegister'

export const StaffDetailsRegister = () => {
  return <StaffRegister/>
}
